import { render, staticRenderFns } from "./Sign-preview.vue?vue&type=template&id=0535448b&scoped=true"
import script from "./Sign-preview.vue?vue&type=script&lang=js"
export * from "./Sign-preview.vue?vue&type=script&lang=js"
import style0 from "./Sign-preview.vue?vue&type=style&index=0&id=0535448b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0535448b",
  null
  
)

export default component.exports